import React from 'react';

// const baseurl = 'http://52.20.204.76:5000';
const baseurl = 'http://54.208.53.142:5003';
//const baseurl = 'http://localhost:5000';

function DownloadsList({ downloadUrls, timeCodeUrls }) {
    return (
        <div>
            <h3>Processed Video Shots:</h3>
            <ul>
                {downloadUrls.map((url, index) => (
                    <li key={index}>
                        <a href={`${baseurl}${url}`} download>Download {index + 1}</a>
                    </li>
                ))}
            </ul>
            <h3>Timecode File:</h3>
            {timeCodeUrls ==null ? '':
            <a href={`${baseurl}${timeCodeUrls}`} download>Download</a>}

        </div>
    );
}

export default DownloadsList;
